import script from "./ColumnSimilar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ColumnSimilar.vue?vue&type=script&lang=ts&setup=true"

import "./ColumnSimilar.vue?vue&type=style&index=0&id=f97f8124&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f97f8124"]])

export default __exports__